<form [formGroup]="vForm">
  <bb-input-text-ui
    label="First Name"
    formControlName="name"
    [required]="true"
    placeholder="Name"
    autoComplete="given-name"
  ></bb-input-text-ui>
</form>
